import type { ReactNode } from 'react'

interface SectionProps {
  title: string
  aside?: ReactNode
  children: ReactNode
  className?: string
}

export function Section({ title, aside, children, className = '' }: SectionProps) {
  return (
    <section className={className}>
      <div className="mb-2 flex min-h-8 flex-wrap items-center justify-between gap-x-3 gap-y-1">
        <h2 className="min-w-0 text-base font-semibold wrap-anywhere">{title}</h2>
        {aside}
      </div>
      {children}
    </section>
  )
}

export function Card({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`rounded-xl bg-card ring-1 ring-line ${className}`}>{children}</div>
}
